// @flow

import axios from 'axios';
import { getBaseUrl } from '../config/config';

export default function getActivityDetail(projectId: string, activityId: string, delayType: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/activities/${activityId}`, {
    params: { delay_type: delayType },
  });
}
